// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "dirty": false,
    "raw": "v0.0.3-0-gd73baad",
    "hash": "gd73baad",
    "distance": 0,
    "tag": "v0.0.3",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v0.0.3",
        "major": 0,
        "minor": 0,
        "patch": 3,
        "prerelease": [],
        "build": [],
        "version": "0.0.3"
    },
    "suffix": "0-gd73baad",
    "semverString": "0.0.3",
    "version": "0.0.3",
    "versionDateTime": "2026-03-02T09:01:07.576Z"
};
